import { Column } from "@ant-design/plots"
import { Spinner } from "components/common"

const BarChart = ({ loading, disabled, isStacked, ...config }) => {
  return loading ? (
    <Spinner size="medium" fullPageSpinner />
  ) : (
    <Column
      legend={{ position: "bottom" }}
      isStack={isStacked}
      label={false}
      style={disabled ? { pointerEvents: "none", opacity: 0.7 } : undefined}
      {...config}
    />
  )
}
export default BarChart
